import styled from 'styled-components'
import DefaultButton from '../Button'

export default styled(DefaultButton).attrs({ type: 'submit' })`
  margin-top: 28px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }
`
